




















import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "Tabs",
  model: {
    prop: "selectedTabKey",
    event: "input"
  },
  props: {
    selectedTabKey: {
      type: [String, Number] as PropType<Props["selectedTabKey"]>,
      required: true
    },
    tabs: {
      type: Array as PropType<Props["tabs"]>,
      required: true
    }
  },
  methods: {
    selectedClass(key: string) {
      return {
        "tabs__labels__label--selected": this.selectedTabKey === key
      };
    }
  }
});
